export const formatString = (value: string) => {
  if (value === 'undefined' || value === 'null') {
    return ''
  }
  return value
}
